import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../services/account.service';
import {  Router } from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';
import {AccountGapDTO} from '../../model/accountGapDTO';
import {AccountDTO} from '../../model/accountDTO';


@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html'
})

export class NotificationDialogComponent implements OnInit {

  accounts: AccountDTO[] = [];
  gaps: AccountGapDTO[] = [];

  constructor(public translate: TranslateService,
    private dialogRef: MatDialogRef<NotificationDialogComponent>,
    private accountService: AccountService,
    private router: Router) {
    translate.use('nl');
   }

  ngOnInit() {
    this.init();
  }

  init() {
    this.accountService.accountsWithUncategorisedTransactions()
      .subscribe( accounts => this.accounts = accounts);
    this.accountService.getGaps().subscribe(gaps => this.gaps = gaps);
  }

  goTo(account) {
    this.close();
    this.router.navigate([`/rekening/${account.id}`]);
  }

  close() {
    this.dialogRef.close();
  }

  printPeriod(period) {
    let result;
    const start = period.start;
    const end = period.end;
    const relation = period.relation;
    switch (period.type) {
      case 'BALANCE':
        if (relation === 'SAME_DAY') {
          result = `${start} heeft geen saldo.`;
        } else if (relation === 'TWO_DAYS') {
          result = `${start} en ${end} hebben geen saldo.`;
        } else if (relation === 'TIME_SPAN') {
          result = `${start} tot en met ${end} hebben geen saldo.`;
        }
        break;
      case 'STATEMENTS':
      case 'MISSING_TRANSACTIONS':
        if (relation === 'SAME_DAY') {
          result = `${start} mist transacties.`;
        } else if (relation === 'TWO_DAYS') {
          result = `${start} en ${end} missen transacties.`;
        } else if (relation === 'TIME_SPAN') {
          result = `${start} tot en met ${end} missen transacties.`;
        }
        break;
    }
    return result;
  }

}
